import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { twMerge } from 'tailwind-merge';

import { getTestProps } from '../../lib/helpers';

import Button from '../../components/Button/Button';
import TopbarBreadcrumbs from '../../components/Topbar/breadcrumbs/TopbarBreadcrumbs';

import useSelectedSpace from '../../hooks/useSelectedSpace';

import { WarningIcon, ZoomMaleWorkingImage } from '../../images/shapes';

import PageLayout, {
  predefinedLayoutClasses,
} from '../../layout/PageLayout/PageLayout';

const testId = 'content-empty';

const ContentEmpty = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { buildUrlWithSpace } = useSelectedSpace();

  return (
    <PageLayout
      page="content"
      title={t('Global.Content')}
      breadcrumbs={<TopbarBreadcrumbs />}
      testId={testId}
    >
      <div className={predefinedLayoutClasses.whiteBox}>
        <ZoomMaleWorkingImage className="flex h-48" />

        <div className="w-full flex flex-col justify-center items-center">
          <p
            className={twMerge(
              'flex items-center text-slate-900 dark:text-white my-8 font-bold ',
              'text-2xl lg:text-4xl xl:text-5xl xl:leading-[52px]',
            )}
          >
            <WarningIcon className="text-red h-10 mr-3" />
            {t('Global.ContentNoItemInTheMenu')}
          </p>

          <Button
            onClick={() =>
              navigate(buildUrlWithSpace('content-type-definitions'))
            }
            {...getTestProps(testId, 'back-definition-builder')}
          >
            {`${t('Global.BackTo')} ${t('Global.DefinitionBuilder')}`}
          </Button>
        </div>
      </div>
    </PageLayout>
  );
};

export default ContentEmpty;
